import Section from '../components/Section';
import { DataContainer } from '../components/DataContainer';
import { fetch } from "../store/shownDataSlice";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from "react";

import FNS from '../api';
import MyJobsToday from '../tables/MyJobsToday';
import MyJobsUpcoming from '../tables/MyJobsUpcoming';
import MyFeedbacklessJobs from '../tables/MyFeedbacklessJobs';




function DriverHome() {
    const dispatch = useDispatch();
  
    useEffect(() => {
        dispatch(fetch.myUpcomingJobs());
    }, []);

    return (
        <div className="column g32 p32">
            <div className="row g16">
                <button onClick={() => {dispatch(fetch.myUpcomingJobs()); dispatch(fetch.myFeedbacklessJobs()); }}>Värskenda</button>
            </div>

            <Section title="Tehtud tööd (vajavad tagasisidet)" initiallyHidden={true} >
                <DataContainer actionType={'shownData/fetch/myFeedbacklessJobs'}>
                    <MyFeedbacklessJobs />
                </DataContainer>
            </Section>

            <Section title="Tänased tööd">
                <DataContainer actionType={'shownData/fetch/myUpcomingJobs'}>
                    <MyJobsToday />
                </DataContainer>
            </Section>

            <Section title="Tulevased tööd">
                <DataContainer actionType={'shownData/fetch/myUpcomingJobs'}>
                    <MyJobsUpcoming />
                </DataContainer>
            </Section>
        </div>
    );
}

export default DriverHome;